import React from "react";
import { Button, ButtonProps } from "antd";

function DynamicButton(props: ButtonProps) {
  return <Button {...props}>{props.children}</Button>;
}

export default DynamicButton;
